import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { sendNotification } from 'src/redux/actions/notifications';
import {
  addTailoring,
  deleteTailoring,
  findAllTailoring
} from 'src/redux/actions/tailoring';
import { findAllExperience } from 'src/redux/actions/experience';
import { findAllSpecial } from 'src/redux/actions/special';
import { withRouter, Link } from 'react-router-dom';
import { findAllSites, findAllSitesInventory, setSelectedSite } from 'src/redux/actions/sites';
import {
  addStock,
  deleteStock,
  findAllStock,
  findAllStockRequests
} from 'src/redux/actions/stock';
import { findAllUsers } from 'src/redux/actions/admin';
import { findChecklistRuns } from 'src/redux/actions/checklists';
import { getSitesAvailableToUser } from 'src/utils/siteAccess';

class Tailoring extends Component {
  render = () => {
    const {
      Layout,
      tailoring,
      special,
      experience,
      user,
      findAllStockRequests,
      findAllSpecial,
      findAllTailoring,
      findAllExperience,
      addTailoring,
      deleteTailoring,
      findAllSites,
      findAllSitesInventory,
      sites,
      inventorySites,
      stock,
      findAllStock,
      findAllUsers,
      addStock,
      deleteStock,
      sendNotification,
      push,
      history,
      findAllTailoringUpdatedToday
    } = this.props;
    return (
      <Layout
        tailoring={tailoring}
        special={special}
        findAllSpecial={findAllSpecial}
        findAllStockRequests={findAllStockRequests}
        experience={experience}
        user={user}
        addTailoring={addTailoring}
        stock={stock}
        findAllStock={findAllStock}
        findAllExperience={findAllExperience}
        findAllUsers={findAllUsers}
        addStock={addStock}
        deleteStock={deleteStock}
        findAllTailoring={findAllTailoring}
        deleteTailoring={deleteTailoring}
        sendNotification={sendNotification}
        findAllSites={findAllSites}
        findAllSitesInventory={findAllSitesInventory}
        sites={sites}
        selectedSite={this.props.selectedSite}
        setSelectedSite={this.props.setSelectedSite}
        inventorySites={inventorySites}
        checklistRuns={this.props.checklistRuns}
        findChecklistRuns={this.props.findChecklistRuns}
        push={push}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  selectedSite: state.sites.selectedSite || null,
  special: state.special.allSpecial || [],
  experience: state.experience.allExperience || [],
  tailoring: state.tailoring.allTailoring || [],
  stock: state.stock.allStock || [],
  sites: getSitesAvailableToUser(
    state.sites.allSites || [],
    state.user.user || {}
  ),
  inventorySites: state.sites.inventorySites || [],
  checklistRuns: (state.checklists && state.checklists.runs) || [],
  user: state.user.user || {}
});

const mapDispatchToProps = {
  setSelectedSite,
  findAllStock,
  findAllUsers,
  findAllSpecial,
  findAllStockRequests,
  addStock,
  findAllSitesInventory,
  findAllExperience,
  deleteStock,
  addTailoring,
  deleteTailoring,
  findAllTailoring,
  sendNotification,
  findAllSites,
  findChecklistRuns,
  push
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Tailoring)
);
